@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }">
  @if (isavailablefeature('view')) {
    <div class="apply-form-main bg-light" [ngClass]="{ 'dark-backround-main': selectedMode === 'dark' }"
      >
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-2 mt-2 heading-main">
          <h5>Orgnization</h5>
          @if (isavailablefeature('add')) {
            <div class="btn btn-primary add-button" data-toggle="modal" data-target="#organizationModal"
              >+ Add Organization
            </div>
          }
        </div>
        <!-- table -->
        <div class="table-main-section">
          <table>
            <tr [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <th>Name</th>
              <th>Slogan</th>
              <th>Type</th>
              <th>City</th>
            </tr>
            @for (data of orgDetail; track data) {
              <tr>
                <td>{{data.name}}</td>
                <td>{{data.slogan}}</td>
                <td>{{data.type}}</td>
                <td>{{data.city}}</td>
              </tr>
              <tr class="last-tr">
                <td>Address</td>
                <td colspan="2">{{data.address1}}{{data.address2}}</td>
                <td>
                  <div class="row">
                    @if (isavailablefeature('edit')) {
                      <div class="col-6 icons">
                        <i class="fa fa-edit edit" (click)="openorgmodal(data)"></i>
                      </div>
                    }
                    @if (isavailablefeature('delete')) {
                      <div class="col-6 icons">
                        <i class="fa fa-trash delete" (click)="deleteOrg(data.id)"></i>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-2 mt-2 heading-main">
          <h5>Designations </h5>
          @if (isavailablefeature('add')) {
            <div class="btn btn-primary add-button" data-toggle="modal" data-target="#designationModal"
              (click)="cleardesmodal()">+ Add Designation
            </div>
          }
        </div>
        <!-- table -->
        <div class="table-main-section">
          <table>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th></th>
              @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                <th>Action</th>
              }
            </tr>
            @for (data of desDetail; track data) {
              <tr class="last-tr">
                <td>{{data.designation_name}}</td>
                <td colspan="2">{{data.description}}</td>
                <td>
                  @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                    <div class="row">
                      @if (isavailablefeature('edit')) {
                        <div class="col-6 icons">
                          <i class="fa fa-edit edit" (click)="opendesmodal(data)"></i>
                        </div>
                      }
                      @if (isavailablefeature('delete')) {
                        <div class="col-6 icons">
                          <i class="fa fa-trash delete" (click)="deletedes(data.id)"></i>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
      <!-- departments -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-2 mt-2 heading-main">
          <h5>Departments</h5>
          @if (isavailablefeature('add')) {
            <div class="btn btn-primary add-button" data-toggle="modal" data-target="#deparmentModal"
            (click)="cleardepmodal()">+ Add Department</div>
          }
        </div>
        <!-- table -->
        <div class="table-main-section">
          <table>
            <tr>
              <th>Deparment Name</th>
              <th>Sub Department Name</th>
              <th></th>
              @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                <th>Action</th>
              }
            </tr>
            @for (data of depDetail; track data) {
              <tr class="last-tr">
                <td>{{data.department_name}}</td>
                <td colspan="2">{{data.sub_department_name}}</td>
                <td>
                  @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                    <div class="row">
                      @if (isavailablefeature('edit')) {
                        <div class="col-6 icons">
                          <i class="fa fa-edit edit" (click)="opendepmodal(data)"></i>
                        </div>
                      }
                      @if (isavailablefeature('delete')) {
                        <div class="col-6 icons">
                          <i class="fa fa-trash delete" (click)="deletedep(data.id)"></i>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
      <!-- policies -->
      <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <div class="mb-2 mt-2 heading-main">
          <h5>Polices</h5>
          @if (isavailablefeature('add')) {
            <div class="btn btn-primary add-button" (click)="addpolicy()">+ Add Policy
            </div>
          }
        </div>
        <!-- policy table -->
        <div class="table-main-section">
          <table>
            <tr>
              <th>Name</th>
              <th>Date</th>
              <th>
                <div class="row">
                  @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                    <div class="col-6">
                      Action
                    </div>
                  }
                  <div class="col-6">
                    <div class="col-6 icons">
                      <i class="fa fa-eye eye" (click)="gotoPolicyPage()"></i>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
            @for (data of policyDetail; track data) {
              <tr>
                <td>{{data.policy_title}}</td>
                <td>{{ data.created_at | date: 'yyyy-MM-dd' }}</td>
                <td>
                  @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                    <div class="row">
                      @if (isavailablefeature('edit')) {
                        <div class="col-6 icons">
                          <i class="fa fa-edit edit" (click)="editPolicy(data)"></i>
                        </div>
                      }
                      @if (isavailablefeature('delete')) {
                        <div class="col-6 icons">
                          <i class="fa fa-trash delete" (click)="deletepolicy(data.id)"></i>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
              <!-- <tr>
              <td>Description</td>
              <td colspan="3" style="text-align: justify;">{{data.policy_description}}</td>
            </tr> -->
          }
        </table>
      </div>
    </div>
    <!-- Leave Management  -->
    <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="mb-2 mt-2 heading-main">
        <h5>Leaves System </h5>
        <div class="total_leaves">
          <h5>Total Leaves : <span>{{total_leaves}}</span></h5>
        </div>
        <div class="total_leaves">
          <h5>Paid Leave : <span>{{paidLeavesCount}}</span></h5>
        </div>
        <div class="total_leaves">
          <h5>Un Paid Leaves : <span>{{unpaidLeavesCount}}</span></h5>
        </div>
        @if (isavailablefeature('add')) {
          <div class="btn btn-primary add-button" data-toggle="modal" data-target="#leavesModal"
          (click)="clearleavemodal()">+ Add Leave</div>
        }
      </div>
      <!-- table -->
      <div class="table-main-section">
        <table>
          <tr>
            <th>Leave Name</th>
            <th>Leave Type</th>
            <th>Leave Count</th>
            <th>Team Lead Action</th>
            <th>Gender Applicability</th>
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <th>Action</th>
            }
          </tr>
          @for (data of leaveDetail; track data) {
            <tr class="last-tr">
              <td>{{data.leave_name | titlecase}}@if (data.compulsary_leave == 1) {
                <span class="essential-leave"
                >Essential</span>
              }
            </td>
            <td>{{data.leave_type}}</td>
            <td>{{data.leave_count}}</td>
            @if (data.team_lead_action_type == 0) {
              <td> Recommendation</td>
            }
            @if (data.team_lead_action_type == 1) {
              <td>Approval</td>
            }
            @if (data.gender_applicability == 1) {
              <td>Male only</td>
            }
            @if (data.gender_applicability == 0) {
              <td>Female only</td>
            }
            @if (data.gender_applicability == 2) {
              <td>Both</td>
            }
            <td>
              @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                <div class="row">
                  @if (isavailablefeature('edit')) {
                    <div class="col-6 icons">
                      <i class="fa fa-edit edit" (click)="opendleavemodal(data)"></i>
                    </div>
                  }
                  @if (isavailablefeature('delete')) {
                    <div class="col-6 icons">
                      <i class="fa fa-trash delete" (click)="deletedleave(data.id)"></i>
                    </div>
                  }
                </div>
              }
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
  <!-- expenses -->
  <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
    <div class="mb-2 mt-2 heading-main">
      <h5>Expense List</h5>
      @if (isavailablefeature('add')) {
        <div class="btn btn-primary add-button" data-toggle="modal" data-target="#categoryModal"
        (click)="clearcatmodal()">+ Add Category</div>
      }
    </div>
    @for (data of subCatDetail; track data; let i = $index) {
      <div class="mb-2 mt-2 sub-heading">
        <div class="col-12">
          <div class="row">
            <div class="col-2">
              <h5 class="capital-heading"><span>{{i+1}}- </span>{{data.category.name}}</h5>
            </div>
            <div class="col-1 subcat-icons">
              <div class="add-button-plus" data-toggle="modal" data-target="#subcategoryModal"
                (click)="subcatClick(data.category.id)"> <i class="fa fa-plus-circle"></i> </div>
                <div class="delete-button"><i class="fa fa-trash" (click)="deleteCategory(data.category.id)"></i></div>
              </div>
            </div>
          </div>
        </div>
        <!-- sub category table -->
        <div class="table-main-section">
          <table>
            <tr>
              <th>Name</th>
              <th>Amount</th>
              <th>Due Date</th>
              <th>Is Media</th>
              <th>Status</th>
              @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                <th>Action</th>
              }
            </tr>
            @for (subcategory of data.category.subcategories; track subcategory) {
              <tr class="last-tr">
                <td>{{subcategory.name}}</td>
                @if (subcategory.amount != undefined || subcategory.amount != null) {
                  <td>{{subcategory.amount}}</td>
                }
                @if (subcategory.amount == undefined || subcategory.amount == null) {
                  <td>0</td>
                }
                <td>{{subcategory.last_date}}</td>
                @if (subcategory.is_media == 0) {
                  <td>False</td>
                }
                @if (subcategory.is_media == 1) {
                  <td>True</td>
                }
                @if (subcategory.status != undefined || subcategory.status != null) {
                  <td>{{ subcategory.status }}</td>
                }
                @if (subcategory.status == undefined || subcategory.status == null) {
                  <td>Pending</td>
                }
                <td>
                  @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                    <div class="row">
                      @if (isavailablefeature('edit')) {
                        <div class="col-6 icons">
                          <i class="fa fa-edit edit" (click)="opensubcatmodal(subcategory)"></i>
                        </div>
                      }
                      @if (isavailablefeature('delete')) {
                        <div class="col-6 icons">
                          <i class="fa fa-trash delete" (click)="deletesubcat(subcategory.id)"></i>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      }
    </div>
    <!-- default common keys Management  -->
    <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="mb-2 mt-2 heading-main">
        <h5>User Checks System </h5>
        @if (isavailablefeature('add')) {
          <div class="btn btn-primary add-button" data-toggle="modal" data-target="#keysModal" (click)="clearkeymodal()"
            >+
          Add checks</div>
        }
      </div>
      <!-- table -->
      <div class="table-main-section common-keys">
        <table>
          <tr>
            <th>
              <div class="device-check-th">
                Device Check
                <div class="info-check">
                  <i class="fa fa-info-circle"></i>
                  <span class="tooltiptext">It Work on Attendance it Check Radius and Device id from User</span>
                </div>
              </div>
            </th>
            <td>
              @if (deviceKey === 'true') {
                <div class="on common-check">
                  On
                </div>
              }
              @if (deviceKey === 'false') {
                <div class="off common-check">
                  Off
                </div>
              }
            </td>
          </tr>
          <tr>
            <th>
              <div class="device-check-th">
                Authentication Check
                <div class="info-check">
                  <i class="fa fa-info-circle"></i>
                  <span class="tooltiptext">It set Google Authentication on login Screen</span>
                </div>
              </div>
            </th>
            <td>
              @if (auth_key === 'true') {
                <div class="on common-check">
                  On
                </div>
              }
              @if (auth_key === 'false') {
                <div class="off common-check">
                  Off
                </div>
              }
            </td>
          </tr>
          <tr>
            <th>
              <div class="device-check-th">
                Leave Check
                <div class="info-check">
                  <i class="fa fa-info-circle"></i>
                  <span class="tooltiptext">It set Leave Annual and Monthly</span>
                </div>
              </div>
            </th>
            <td>
              @if (leaveKey === 'true') {
                <div class="on common-check">
                  On
                </div>
              }
              @if (leaveKey === 'false') {
                <div class="off common-check">
                  Off
                </div>
              }
            </td>
          </tr>
          <tr>
            <th>
              <div class="device-check-th">
                Leave Set Date
                <div class="info-check">
                  <i class="fa fa-info-circle"></i>
                  <span class="tooltiptext1">Enter Date When You want to Reset Your Leaves</span>
                </div>
              </div>
            </th>
            <td>
              {{leaveDate}}
            </td>
          </tr>
          <tr class="last-tr">
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <th>Action</th>
            }
            <td>
              @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                <div class="row">
                  @if (isavailablefeature('edit')) {
                    <div class="col-6 icons">
                      <i class="fa fa-edit edit" (click)="opendkeysmodal()"></i>
                    </div>
                  }
                  @if ( isavailablefeature('delete')) {
                    <div class="col-6 icons">
                      <i class="fa fa-trash delete" (click)="deletedkey(keysid)"></i>
                    </div>
                  }
                </div>
              }
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- KpS List section -->
    <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="mb-2 mt-2 heading-main">
        <h5>User KPS List / Evaluatin Points </h5>
        @if (isavailablefeature('add')) {
          <div class="btn btn-primary add-button" data-toggle="modal" data-target="#kpslistModal"
          (click)="clearkeymodal()">+ Add List</div>
        }
      </div>
      <!-- table -->
      <div class="table-main-section kps-list-table">
        <table>
          <tr>
            <th class="kps_title">Name</th>
            <th>Value</th>
            <th>Type</th>
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <th>Action</th>
            }
          </tr>
          @for (data of kpsData; track data) {
            <tr class="last-tr">
              <td class="kps_title">{{data.title}}</td>
              <td>{{data.value}}</td>
              <td>{{data.type}}</td>
              <td>
                @if (isavailablefeature('edit') || isavailablefeature('delete')) {
                  <div class="row">
                    @if (isavailablefeature('edit')) {
                      <div class="col-6 icons">
                        <i class="fa fa-edit edit" (click)="opendkpsmodal(data)"></i>
                      </div>
                    }
                    @if (isavailablefeature('delete')) {
                      <div class="col-6 icons">
                        <i class="fa fa-trash delete" (click)="deletedkps(data.id)"></i>
                      </div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
    <!-- policies -->
    <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="mb-2 mt-2 heading-main">
        <h5>Setup Text Automation</h5>
        @if (isavailablefeature('add')) {
          <div class="btn btn-primary add-button" (click)="addTextAutomation()">+ Setup
          Text Automation</div>
        }
      </div>
    </div>
    <!-- user role section -->
    <div class="create-form pt-2 pl-4 pr-4 border" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="mb-2 mt-2 heading-main">
        <h5>Roles Setup</h5>
        @if (isavailablefeature('add')) {
          <div class="btn btn-primary add-button" (click)="addUserRole()">+ Add Roles
          </div>
        }
      </div>
      <!-- table -->
      <div class="table-main-section">
        <table>
          <tr [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <th>Role Name</th>
            <th>Role Type</th>
            <th>Created By</th>
            <th>Created Date</th>
            <th>Active</th>
            @if (isavailablefeature('edit') || isavailablefeature('delete')) {
              <th>Action</th>
            }
          </tr>
          @for (data of user_Roles; track data) {
            <tr>
              <td>{{data.role_name}}</td>
              <td>{{data.role_type}}</td>
              <td>{{data.created_by}}</td>
              <td>{{data.created_date}}</td>
              @if (data.is_active == 1) {
                <td>True</td>
              }
              @if (data.is_active == 0) {
                <td>False</td>
              }
              @if (data.is_active == Null) {
                <td>No Data</td>
              }
              <td>
                <div class="row">
                  @if (isavailablefeature('edit') ) {
                    <div class="col-4 icons">
                      <i class="fa fa-edit edit" (click)="onEditClick(data)"></i>
                    </div>
                  }
                  @if ( isavailablefeature('delete')) {
                    <div class="col-4 icons">
                      <i class="fa fa-trash delete" (click)="deleteRole(data.id)"></i>
                    </div>
                  }
                  <div class="col-4 icons">
                    <i class="fa fa-eye eye" (click)="viewRole(data)"></i>
                  </div>
                </div>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  </div>
}


<!-- Modals -->

<!-- add orgnazation modal -->
<div class="modal fade" id="organizationModal" #organizationModal tabindex="-1" role="dialog"
  aria-labelledby="organizationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add New Organization</h5>

      </div>
      <div class="modal-body">
        <form id="form-link-org" name="organization" #org="ngForm" (ngSubmit)="onOrgSubmit(org)">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" name="org_name" id="org_name" [(ngModel)]="editname"
                  placeholder="Organization Name*" class="form-control pl-2" ngModel #org_name="ngModel" required />
                  @if (org_name.touched && org_name.invalid) {
                    <div class="warning">
                      Orgnazation Name is required.
                    </div>
                  }
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" name="org_slogan" id="org_slogan" [(ngModel)]="editslogan"
                    placeholder="Organization Slogan*" class="form-control pl-2" ngModel #org_slogan="ngModel"
                    required />
                    @if (org_slogan.touched && org_slogan.invalid) {
                      <div class="warning">
                        Orgnazation Slogan is required.
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" name="org_type" id="org_type" [(ngModel)]="edittype"
                      placeholder="Organization type*" class="form-control pl-2" ngModel #org_type="ngModel" required />
                      @if (org_type.touched && org_type.invalid) {
                        <div class="warning">
                          Orgnazation Type is required.
                        </div>
                      }
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <input type="text" name="org_city" id="org_city" [(ngModel)]="editcity"
                        placeholder="Organization City*" class="form-control pl-2" ngModel #org_city="ngModel" required />
                        @if (org_city.touched && org_city.invalid) {
                          <div class="warning">
                            Organization City is required.
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <input type="text" name="org_address1" id="org_address1" [(ngModel)]="editaddress1"
                          placeholder="Organization Address 1*" class="form-control pl-2" ngModel #org_address1="ngModel"
                          required />
                          @if (org_address1.touched && org_address1.invalid) {
                            <div class="warning">
                              Orgnazation Address 1 is required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input type="text" name="org_address2" id="org_address2" [(ngModel)]="editaddress2"
                            placeholder="Organization Address 2*" class="form-control pl-2" ngModel #org_address2="ngModel"
                            required />
                            @if (org_address2.touched && org_address2.invalid) {
                              <div class="warning">
                                Orgnazation Address 2 is required.
                              </div>
                            }
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <input type="text" name="org_state" id="org_state" [(ngModel)]="editstate"
                              placeholder="Organization State*" class="form-control pl-2" ngModel #org_state="ngModel" required />
                              @if (org_state.touched && org_state.invalid) {
                                <div class="warning">
                                  Organization State is required.
                                </div>
                              }
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <input type="text" name="org_country" id="org_country" [(ngModel)]="editcountry"
                                placeholder="Organization Country*" class="form-control pl-2" ngModel #org_country="ngModel"
                                required />
                                @if (org_country.touched && org_country.invalid) {
                                  <div class="warning">
                                    Organization Country is required.
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input type="text" name="org_postal_code" id="org_postal_code" [(ngModel)]="editpostalcode"
                                  placeholder="Organization Postal Code*" class="form-control pl-2" ngModel #org_postal_code="ngModel"
                                  required />
                                  @if (org_postal_code.touched && org_postal_code.invalid) {
                                    <div class="warning">
                                      Organization Postal Code is required.
                                    </div>
                                  }
                                </div>
                              </div>

                            </div>
                          </form>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                          <button type="submit" class="btn btn-primary" [disabled]="org.invalid" form="form-link-org">Save
                          changes</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- add Designation modal -->
                  <div class="modal fade" id="designationModal" #designationModal tabindex="-1" role="dialog"
                    aria-labelledby="designationModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                        <div class="modal-header">
                          <h5 class="modal-title" id="designationModalLabel">Add New Designation</h5>

                        </div>
                        <div class="modal-body">
                          <form id="form-link-des" name="designation" #des="ngForm" (ngSubmit)="onDesSubmit(des)">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <input type="text" name="des_name" id="des_name" [(ngModel)]="editdesname"
                                    placeholder="Designation Name*" class="form-control pl-2" ngModel #des_name="ngModel" required />
                                    @if (des_name.touched && des_name.invalid) {
                                      <div class="warning">
                                        Designation Name is required.
                                      </div>
                                    }
                                  </div>
                                </div>


                                <div class="col-md-12">
                                  <div class="form-group">
                                    <select id="orgnazation" name="orgnazation" class="form-control pl-1 selectpicker"
                                      [(ngModel)]="orgSelected" #orgnazation="ngModel" required>
                                      <option value="null" disabled selected>Select Organization</option>
                                      @for (org of orgDetail; track org) {
                                        <option [ngValue]="org">{{org.name}}</option>
                                      }
                                    </select>
                                    @if (orgnazation.touched && orgnazation.invalid) {
                                      <div class="warning">
                                        Organization Selection is required.
                                      </div>
                                    }
                                  </div>
                                </div>



                                <div class="col-md-12">
                                  <div class="form-group">
                                    <textarea id="des_description" name="des_description" rows="4" cols="50"
                                      [(ngModel)]="editdesdescription" placeholder="Description*" class="form-control pl-2" ngModel
                                      #des_description="ngModel" required>
                                    </textarea>
                                    @if (des_description.touched && des_description.invalid) {
                                      <div class="warning">
                                        Designation Description is required.
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                            <button type="submit" class="btn btn-primary" [disabled]="des.invalid" form="form-link-des">Save
                            changes</button>
                          </div>
                        </div>
                      </div>
                    </div>



                    <!-- deparment modal -->
                    <div class="modal fade" id="deparmentModal" #departmentModal tabindex="-1" role="dialog"
                      aria-labelledby="deparmentModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                          <div class="modal-header">
                            <h5 class="modal-title" id="deparmentModalLabel">Add New Department</h5>

                          </div>
                          <div class="modal-body">
                            <form id="form-link-dep" name="deparment" #dep="ngForm" (ngSubmit)="onSubmitdep(dep)">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="form-group">
                                    <input type="text" name="dep_name" id="dep_name" [(ngModel)]="editdepname"
                                      placeholder="Department Name*" class="form-control pl-2" ngModel #dep_name="ngModel" required />
                                      @if (dep_name.touched && dep_name.invalid) {
                                        <div class="warning">
                                          Department Name is required.
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <input type="text" name="subdep_name" id="subdep_name" [(ngModel)]="editsubdep"
                                        placeholder="Sub Department Name*" class="form-control pl-2" ngModel #subdep_name="ngModel"
                                        required />
                                        @if (subdep_name.touched && subdep_name.invalid) {
                                          <div class="warning">
                                            Sub Department Name is required.
                                          </div>
                                        }
                                      </div>
                                    </div>

                                  </div>
                                </form>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                <button type="submit" class="btn btn-primary" [disabled]="dep.invalid" form="form-link-dep">Save
                                changes</button>
                              </div>
                            </div>
                          </div>
                        </div>




                        <!-- category modal -->
                        <div class="modal fade" id="categoryModal" #catmodal tabindex="-1" role="dialog" aria-labelledby="categoryModalLabel"
                          aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                              <div class="modal-header">
                                <h5 class="modal-title" id="policyModalLabel">Add New Expense Category</h5>
                              </div>
                              <div class="modal-body">
                                <form id="form-link-category" name="category" #category="ngForm" (ngSubmit)="oncategorySubmit(category)">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class="form-group">
                                        <input type="text" name="category_name" id="category_name" [(ngModel)]="editcategoryName"
                                          placeholder="Enter Category Name*" class="form-control pl-2" ngModel #category_name="ngModel"
                                          required />
                                          @if (category_name.touched && category_name.invalid) {
                                            <div class="warning">
                                              category Name Title is required.
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                  <button type="submit" class="btn btn-primary" [disabled]="category.invalid" form="form-link-category">Save
                                  changes</button>
                                </div>
                              </div>
                            </div>
                          </div>


                          <!-- Sub category modal -->
                          <div class="modal fade" id="subcategoryModal" #subcatmodal tabindex="-1" role="dialog"
                            aria-labelledby="subcategoryModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                              <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                <div class="modal-header">
                                  <h5 class="modal-title" id="policyModalLabel">Add New Expense Sub Category</h5>
                                </div>
                                <div class="modal-body">
                                  <form id="form-link-subcategory" name="subcategory" #subcategory="ngForm"
                                    (ngSubmit)="onsubcategorySubmit(subcategory)">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <input type="text" name="subcategory_name" id="subcategory_name" [(ngModel)]="editsubcategoryName"
                                            placeholder="Enter Sub Category Name*" class="form-control pl-2" ngModel #subcategory_name="ngModel"
                                            required />
                                            @if (subcategory_name.touched && subcategory_name.invalid) {
                                              <div class="warning">
                                                Subcategory Name Title is required.
                                              </div>
                                            }
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <input type="text" name="subcategory_amount" id="subcategory_amount"
                                              [(ngModel)]="editsubcategoryamount" placeholder="Enter Sub Category Amount*"
                                              class="form-control pl-2" />
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <input type="date" name="subcategory_date" id="subcategory_date" [(ngModel)]="editsubcategorydate"
                                                placeholder="Enter Sub Category Last Date*" class="form-control pl-2" required />
                                              </div>
                                            </div>
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <input type="text" name="subcategory_status" id="subcategory_status"
                                                  [(ngModel)]="editsubcategorystatus" placeholder="Enter Sub Category Status*"
                                                  class="form-control pl-2" />
                                                </div>
                                              </div>
                                              <div class="col-md-6">
                                                <div class="form-group check-box">
                                                  <label>Is Media</label>
                                                  <input type="checkbox" name="is_Media" [(ngModel)]="isMedia" (change)="updateIsMedia()">
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                        <div class="modal-footer">
                                          <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                          <button type="submit" class="btn btn-primary" [disabled]="subcategory.invalid"
                                          form="form-link-subcategory">Save changes</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                  <!-- add leaves modal  -->
                                  <div class="modal fade" id="leavesModal" #leavesModal tabindex="-1" role="dialog" aria-labelledby="leavesModalLabel"
                                    aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                      <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                        <div class="modal-header">
                                          <h5 class="modal-title" id="leavesModalLabel">Add New Leaves</h5>
                                        </div>
                                        <div class="modal-body">
                                          <form id="form-link-addleave" name="addleaves" #addleaves="ngForm" (ngSubmit)="onaddleavesSubmit(addleaves)">
                                            <div class="row ">
                                              <div class="col-md-12">
                                                <div class="form-group">
                                                  <input type="text" name="leave_name" id="leave_name" [(ngModel)]="editleave_name"
                                                    placeholder="Enter Leave Name*" class="form-control pl-2" ngModel #leave_name="ngModel" required />
                                                    @if (leave_name.touched && leave_name.invalid) {
                                                      <div class="warning">
                                                        Leave Name is required*.
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                                <div class="col-md-12">
                                                  <div class="form-group">
                                                    <input type="text" name="leave_count" id="leave_count" [(ngModel)]="editleave_count"
                                                      placeholder="Enter Leave No.*" class="form-control pl-2" />
                                                    </div>
                                                  </div>
                                                  <div class="col-md-12">
                                                    <div class="form-group">
                                                      <select id="leave_type" name="leave_type" class="form-control pl-1 selectpicker"
                                                        [(ngModel)]="leaveselected" #orgnazation="ngModel" required>
                                                        <option value="null" disabled selected>Select Leave Type</option>
                                                        <option value="paid">Paid Leave</option>
                                                        <option value="unpaid">UnPaid Leave</option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                  <div class="col-md-12">
                                                    <div class="form-group">
                                                      <div class="form-group checkbox-design">
                                                        <div>
                                                          <label>Compulsory Leave</label>
                                                          <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="toggleButtonCompulsryLeave"
                                                              [checked]="toggleValueCompulsoryLeave" (change)="toggleChangedCL($event)">
                                                              <label class="custom-control-label" for="toggleButtonCompulsryLeave">
                                                                {{ toggleValueCompulsoryLeave ? 'Yes' : 'No' }}
                                                              </label>
                                                            </div>
                                                          </div>
                                                          <div>
                                                            <label class="ml-5">Team Lead Action</label>
                                                            <div class="custom-control custom-switch ml-5">
                                                              <input type="checkbox" class="custom-control-input" id="toggleValueTLAction"
                                                                [checked]="toggleValueTLAction === 1" (change)="toggleChangedTLAction($event)">
                                                                <label class="custom-control-label" for="toggleValueTLAction"> {{ toggleValueTLAction === 1 ?
                                                                'Approval' : 'Recommendation' }}</label>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-md-12">
                                                        <div class="form-group">
                                                          <select id="gender_applicability" name="gender_applicability" class="form-control pl-1 selectpicker"
                                                            [(ngModel)]="genderApplicability" required>
                                                            <option [ngValue]="null" disabled>Select Gender Applicability</option>
                                                            <option [ngValue]="0">Female Only</option>
                                                            <option [ngValue]="1">Male Only</option>
                                                            <option [ngValue]="2">Both</option>

                                                          </select>
                                                        </div>
                                                      </div>

                                                    </div>
                                                  </form>
                                                </div>
                                                <div class="modal-footer">
                                                  <button type="button" class="btn btn-light" data-dismiss="modal" (click)="closeLeaveModal()">Cancel</button>
                                                  <button type="submit" class="btn btn-primary" [disabled]="addleaves.invalid" form="form-link-addleave">Save
                                                  changes</button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <!-- check modal -->

                                          <div class="modal fade" id="keysModal" #keysModal tabindex="-1" role="dialog" aria-labelledby="keysModalLabel"
                                            aria-hidden="true">
                                            <div class="modal-dialog modal-dialog-centered" role="document">
                                              <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                                <div class="modal-header">
                                                  <h5 class="modal-title" id="keysModalLabel">Add Checks</h5>
                                                </div>
                                                <div class="modal-body keys-modal">
                                                  <form id="form-link-addkeys" name="addkeys" #addkeys="ngForm" (ngSubmit)="onaddkeysSubmit(formModel)">
                                                    <div class="row">
                                                      <div class="col-6">
                                                        <div class="keys-heading">
                                                          <h6>Device Check {{deviceCheck}}</h6>
                                                        </div>
                                                      </div>
                                                      <div class="col-6">
                                                        <div class="keys-data">
                                                          <label class="switch">
                                                            <input type="checkbox" name="deviceCheck" [(ngModel)]="formModel.deviceCheck">
                                                            <span class="slider round"></span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div class="col-6">
                                                        <div class="keys-heading">
                                                          <h6>Leave Check {{leaveCheck}}</h6>
                                                        </div>
                                                      </div>
                                                      <div class="col-6">
                                                        <div class="keys-data">
                                                          <label class="switch">
                                                            <input type="checkbox" name="leaveCheck" [(ngModel)]="formModel.leaveCheck">
                                                            <span class="slider round"></span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                       <div class="col-6">
                                                        <div class="keys-heading">
                                                          <h6>Authentication Check {{authKey}}</h6>
                                                        </div>
                                                      </div>
                                                      <div class="col-6">
                                                        <div class="keys-data">
                                                          <label class="switch">
                                                            <input type="checkbox" name="authKey" [(ngModel)]="formModel.authKey">
                                                            <span class="slider round"></span>
                                                          </label>
                                                        </div>
                                                      </div>

                                                      <div class="col-6">
                                                        <div class="keys-heading">
                                                          <h6>Leave Set Date</h6>
                                                        </div>
                                                      </div>
                                                      <div class="col-6">
                                                        <div class="keys-data">
                                                          <div class="form-group">
                                                            <input type="date" name="keyleave_date" id="keyleave_date" [(ngModel)]="formModel.keyleave_date"
                                                              class="form-control pl-2" ngModel #keyleave_date="ngModel" required />
                                                              @if (keyleave_date.touched && keyleave_date.invalid) {
                                                                <div class="warning">
                                                                  Leave date is required*.
                                                                </div>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                  <div class="modal-footer">
                                                    <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                                    <button type="submit" class="btn btn-primary" [disabled]="addkeys.invalid" form="form-link-addkeys">Save
                                                    changes</button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <!-- kpls list modal -->

                                            <div class="modal fade" id="kpslistModal" #kpslistModal tabindex="-1" role="dialog"
                                              aria-labelledby="kpslistModalLabel" aria-hidden="true">
                                              <div class="modal-dialog modal-dialog-centered" role="document">
                                                <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                                  <div class="modal-header">
                                                    <h5 class="modal-title" id="kpslistModalLabel">Add New KPS List</h5>
                                                  </div>
                                                  <div class="modal-body keys-modal">
                                                    <form id="form-link-kps" name="kpslist" #kpslist="ngForm" (ngSubmit)="onaddkpsSubmit(kpslist)">
                                                      <div class="row">
                                                        <div class="col-md-12">
                                                          <div class="form-group">
                                                            <input type="text" name="kps_name" id="kps_name" [(ngModel)]="editkps_name"
                                                              placeholder="Enter KPS Name*" class="form-control pl-2" ngModel #kps_name="ngModel" required />
                                                              @if (kps_name.touched && kps_name.invalid) {
                                                                <div class="warning">
                                                                  KPS Name is required*.
                                                                </div>
                                                              }
                                                            </div>
                                                          </div>
                                                          <div class="col-md-12">
                                                            <div class="form-group">
                                                              <select id="employee_role" [ngModel]="editemployee_role" name="employee_role" data-toggle="dropdown"
                                                                class="dropdown-toggle checks-dropdown form-control pl-2 selectpicker" ngModel
                                                                #employee_role="ngModel" required>
                                                                <option value="null" disabled selected hidden>Select Type</option>
                                                                @for (role of office_roles_array; track role) {
                                                                  <option [value]="role.role_names">{{ role.role_names }}
                                                                  </option>
                                                                }
                                                              </select>
                                                              @if (employee_role.touched && employee_role.invalid) {
                                                                <div class="warning">
                                                                  Select Type
                                                                </div>
                                                              }
                                                            </div>
                                                          </div>
                                                          <div class="col-md-12">
                                                            <div class="form-group">
                                                              <input type="text" name="kps_value" id="kps_value" [(ngModel)]="editkps_value"
                                                                placeholder="Enter KPS Value*" class="form-control pl-2" ngModel #kps_value="ngModel" required />
                                                                @if (kps_value.touched && kps_value.invalid) {
                                                                  <div class="warning">
                                                                    KPS Value is required*.
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>



                                                          </div>
                                                        </form>
                                                      </div>
                                                      <div class="modal-footer">
                                                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancel</button>
                                                        <button type="submit" class="btn btn-primary" [disabled]="kpslist.invalid" form="form-link-kps">Save
                                                        changes</button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                              </main>